import { increment } from 'vuex-easy-firestore';
import fb from '@/firebaseConfig';

export default {
  async addCardNote(
    { dispatch, getters, rootState, state },
    {
      pageId,
      cardId = false,
      parentNoteId = false,
      html = null,
      widgetInfo = false,
      order = undefined,
      type,
      pageType = 0,
      embeddedPageId = false
    }
  ) {
    //throw an error if anythin is missing
    if (html == null && !widgetInfo) {
      throw 'no html field was provided for the new note';
    }
    if (order !== undefined && isNaN(order)) {
      throw 'the order provided is not a number';
    }
    if (pageId == undefined) {
      throw 'no pageId was provided for the new note';
    }
    // if (!cardId && !parentNoteId) {
    //   throw 'no cardId or parentNoteId was provided for the new note';
    // }

    // get the sibling note blocks to determine last item order and to update order later
    const page = state.pages[pageId];
    const siblingNotes = Object.values(page.pageNotes).filter(n => !n.toDelete);
    // Object.values(page.pageNotes).filter(n =>
    //   cardId ? n.cardId == cardId : n.parentNoteId == parentNoteId
    // );
    let updatedOrder = false;
    const orders = siblingNotes
      .sort((a, b) => (a.order > b.order ? 1 : -1))
      .map((n, i) => ({ id: n.id, order: n.order, index: i }));
    console.log(orders);
    //  check if orders are off
    if (orders.find(n => n.order !== n.index)) {
      console.log('fix orders');
      //  just fix them all
      siblingNotes.map(n => {
        n.order = orders.find(o => o.id == n.id).index;
      });
      updatedOrder = true;
      //  check
      console.log(
        siblingNotes
          .sort((a, b) => (a.order > b.order ? 1 : -1))
          .map((n, i) => ({ id: n.id, order: n.order, index: i }))
      );
    }

    const newOrder = order !== undefined ? order : siblingNotes.length;

    //get necessary Id's (generated for new Id and user ID for created by)
    const id = getters['dbRef'].doc().id;
    const userId = rootState.auth.currentUser.uid;

    //  if this is an card type, create a new page

    //create the update object for the addition of the note
    const noteUpdate = {};
    const { widgetType, widgetData } = widgetInfo;
    noteUpdate[id] = {
      id,
      createdBy: userId,
      createdOn: new Date(),
      updatedOn: fb.util.timestamp.now(),
      order: newOrder,
      cardId: cardId,
      parentNoteId,
      type: type ? type : widgetType ? 'widget' : 'note',
      content: {
        html,
        widgetType: widgetType || null,
        widgetData: widgetData || {}
      }
    };

    if (type == 'card') {
      let pageId;
      if (embeddedPageId) {
        pageId = embeddedPageId;
      } else {
        pageId = await dispatch('addPage', {
          section: false,
          order: 0,
          title: html,
          noWait: true,
          pageType
        });
      }
      noteUpdate[id].pageId = pageId;
    }

    //update all the other notes that have a greater order than the one being added to be +1
    siblingNotes.forEach(noteBlock => {
      if (noteBlock.order >= newOrder) {
        noteUpdate[noteBlock.id] = {
          order: increment(1)
        };
      } else if (updatedOrder) {
        noteUpdate[noteBlock.id] = {
          order: noteBlock.order
        };
      }
    });

    // if (widgetType === 'resource' && 'resourceId' in widgetData) {
    //   if (!page.syncIds.includes(widgetData.resourceId)) {
    //     console.log(`updating syncIds with resource: ${widgetData.resourceId}`);
    //     dispatch('patch', { id: pageId, syncIds: arrayUnion(widgetData.resourceId) });
    //   }
    // }

    console.log('noteUpdate', noteUpdate);
    //update vuex and database with vuex-easy-firestore
    dispatch('patch', { id: pageId, pageNotes: noteUpdate });
    dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    dispatch('batchSync');
    return id;
  },
  removeNote({ dispatch, state }, { noteId, cardId, pageId }) {
    console.log('remove note', noteId);
    //get necessary Id's
    if (!noteId) {
      throw 'no NoteBlockId was provided for the note you want to remove';
    }
    if (!pageId) {
      throw 'no pageId was provided for the note you want to remove';
    }

    // if (!cardId) {
    //   throw 'no cardId was provided for the note you want to remove';
    // }

    //find it's order and update all the ones with order greater than it

    const page = state.pages[pageId];
    const currentNoteBlock = page.pageNotes[noteId];
    const parentNoteId = currentNoteBlock.parentNoteId;
    const siblingNotes = Object.values(page.pageNotes).filter(n => !n.toDelete);
    const { order } = currentNoteBlock;
    const noteBlocksUpdate = {};
    siblingNotes.forEach(noteBlock => {
      if (noteBlock.order > order) {
        noteBlocksUpdate[noteBlock.id] = {
          order: increment(-1)
        };
      }
    });

    //  Get any subnotes and mark them to delete
    // if (!parentNoteId) {
    //   const subNotes = Object.values(page.pageNotes).filter(
    //     n => n.parentNoteId == noteId && !n.toDelete
    //   );
    //   subNotes.forEach(n => {
    //     noteBlocksUpdate[n.id] = {
    //       toDelete: true
    //     };
    //   });
    // }

    //mark to delete the field that we no longer need
    noteBlocksUpdate[noteId] = {};
    noteBlocksUpdate[noteId].toDelete = true;

    //update the orders if the object length is not 0
    if (Object.keys(noteBlocksUpdate).length !== 0) {
      dispatch('patch', { id: pageId, notesToDelete: true, pageNotes: noteBlocksUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    } else {
      console.log('no order needed updated');
    }
  },
  async convertNoteToCard({ dispatch, state }, { text, noteId, pageId, cardsToGroup }) {
    //  create a new page
    const id = await dispatch('addPage', { section: false, order: 0, title: text, noWait: true });
    if (cardsToGroup && cardsToGroup.length) {
      //  get note
      const note = state.pages[pageId].pageNotes[noteId];
      dispatch('moveNoteById', {
        noteIds: cardsToGroup,
        moveToPageId: id,
        moveFromPageId: pageId,
        moveToPosition: 0
      });
      //  create a new note to house this note
      dispatch('addCardNote', {
        pageId,
        html: text,
        order: note.order,
        type: 'card',
        embeddedPageId: id
      });
    } else {
      //  convert this note
      const noteBlockUpdate = {};
      noteBlockUpdate[noteId] = { type: 'card', pageId: id };

      //update vuex and database with vuex-easy-firestore
      await dispatch('patch', { id: pageId, pageNotes: noteBlockUpdate });
    }

    return true;
  },
  async convertCardToNote({ dispatch, state }, { text, noteId, pageId }) {
    //  create a new page
    const noteBlockUpdate = {};
    noteBlockUpdate[noteId] = { type: 'note', pageId: false };

    //update vuex and database with vuex-easy-firestore
    await dispatch('patch', { id: pageId, pageNotes: noteBlockUpdate });
    return true;
  },
  duplicateNotes({ dispatch, state }, { noteIds, startingPosition, fromPageId, toPageId }) {
    console.log(state.pages[fromPageId], noteIds)
    const notes = noteIds
      .map(n => state.pages[fromPageId].pageNotes[n])
      .sort((a, b) => (a.order < b.order ? -1 : 1));

    notes.forEach((n, index) => {
      dispatch('addCardNote', {
        pageId: toPageId,
        html: n.content ? n.content.html : '',
        embeddedPageId: n.pageId,
        type: n.type,
        widgetInfo: { widgetType: n.content.widgetType, widgetData: n.content.widgetData },
        order: startingPosition + index
      });
    });
  },
  popNoteBlock({ state, dispatch }, { pageId, noteId }) {
    const note = state.pages[pageId].pageNotes[noteId];
    const notePage = state.pages[note.pageId];
    const noteIds = Object.values(notePage.pageNotes)
      .filter(n => !n.toDelete)
      .map(n => n.id);
    dispatch('moveNoteById', {
      noteIds,
      moveToPageId: pageId,
      moveFromPageId: notePage.id,
      moveToPosition: note.order
    });
    //  remove the previous note
    const noteBlocksUpdate = {};
    noteBlocksUpdate[noteId] = {};
    noteBlocksUpdate[noteId].toDelete = true;
    dispatch('patch', { id: pageId, notesToDelete: true, pageNotes: noteBlocksUpdate });
  },
  updateNoteHTML({ dispatch }, { pageId, noteId, html }) {
    //get necessary Id's
    if (!html) {
      throw 'no html field was provided for the updated noteblock html';
    }
    if (!noteId) {
      throw 'no noteId was provided for the noteblock you want to update';
    }
    if (!pageId) {
      throw 'no pageId was provided for the noteblock you want to update';
    }

    //create the update object
    const noteBlockUpdate = {};
    noteBlockUpdate[noteId] = { content: { html }, updatedOn: fb.util.timestamp.now() };

    //update vuex and database with vuex-easy-firestore
    dispatch('patch', { id: pageId, pageNotes: noteBlockUpdate });
    dispatch('context/addToAuthorIfNecessary', {}, { root: true });
  },
  setShowNoteSource({ dispatch }, { pageId, noteId, value }) {
    //get necessary Id's
    if (!noteId) {
      throw 'no noteId was provided for the noteblock you want to update';
    }
    if (!pageId) {
      throw 'no pageId was provided for the noteblock you want to update';
    }

    //create the update object
    const noteBlockUpdate = {};
    noteBlockUpdate[noteId] = { showSource: value, updatedOn: fb.util.timestamp.now() };

    //update vuex and database with vuex-easy-firestore
    dispatch('patch', { id: pageId, pageNotes: noteBlockUpdate });
    // dispatch('context/addToAuthorIfNecessary', {}, { root: true });
  },
  setNoteOpen({ dispatch }, { pageId, noteId, value }) {
    //get necessary Id's
    if (!noteId) {
      throw 'no noteId was provided for the noteblock you want to update';
    }
    if (!pageId) {
      throw 'no pageId was provided for the noteblock you want to update';
    }

    //create the update object
    const noteBlockUpdate = {};
    noteBlockUpdate[noteId] = { open: value, updatedOn: fb.util.timestamp.now() };

    //update vuex and database with vuex-easy-firestore
    dispatch('patch', { id: pageId, pageNotes: noteBlockUpdate });
    // dispatch('context/addToAuthorIfNecessary', {}, { root: true });
  },
  moveNoteById({ dispatch, state }, { noteIds, moveToPageId, moveFromPageId, moveToPosition }) {
    if (noteIds.constructor !== Array) {
      throw 'input ordersToMove was either not provided or is not an array please check your function inputs and try again';
    }
    if (isNaN(moveToPosition)) {
      throw 'moveLocation was either not provided or is not a number please check your function inputs and try again';
    }
    if (moveToPageId == undefined) {
      throw 'input pageId was either not provided or undefined please check your function inputs and try again';
    }
    console.log(noteIds, moveToPageId, moveFromPageId, moveToPosition);

    //get the noteBlocks we are intersted in and convert them to an array
    const pageNotes = state.pages[moveFromPageId].pageNotes;
    const notesToMove = noteIds.map(n => pageNotes[n]);
    const firstNoteOriginalOrder = notesToMove[0].order;
    const lastNoteOriginalOrder = notesToMove[notesToMove.length - 1].order;
    const moveToPageNotes = Object.values(state.pages[moveToPageId].pageNotes).filter(
      n => !n.toDelete
    );
    const update = {};
    const toUpdate = {};
    if (moveToPageId == moveFromPageId) {
      console.log('move within page');
      let distance;
      //  we are moving notes within the same card
      console.log(firstNoteOriginalOrder, lastNoteOriginalOrder);
      if (moveToPosition < firstNoteOriginalOrder) {
        console.log('moving up page');
        // we are moving notes up the page
        const notesToAdjust = moveToPageNotes.filter(
          n => n.order < firstNoteOriginalOrder && n.order >= moveToPosition
        );
        notesToAdjust.forEach(n => {
          update[n.id] = { order: n.order + notesToMove.length };
        });
        notesToMove.forEach((n, i) => {
          update[n.id] = { order: moveToPosition + i };
        });
      } else {
        console.log('moving down page');
        //  we are moving notes down the page
        const notesToAdjust = moveToPageNotes.filter(
          n => n.order > lastNoteOriginalOrder && n.order <= moveToPosition
        );
        notesToAdjust.forEach((n, i) => {
          update[n.id] = { order: n.order - notesToMove.length };
        });
        notesToMove.forEach((n, i) => {
          update[n.id] = { order: moveToPosition - (notesToMove.length - 1) + i };
        });
      }
    } else {
      // we a moving notes to a different card
      const moveFromPageNotes = Object.values(pageNotes).filter(n => !n.toDelete);
      // setup the cards that will move
      const orderedNotesToMove = notesToMove.sort((a, b) => (a.order > b.order ? 1 : -1));

      // delete notes from fromPage
      orderedNotesToMove.forEach((n, i) => {
        update[n.id] = { toDelete: true };
      });
      // fix the order of the moveFromCard notes
      moveFromPageNotes.forEach(n => {
        if (n.order > lastNoteOriginalOrder) {
          update[n.id] = { order: n.order - noteIds.length };
        }
      });

      // add notes to toPage
      orderedNotesToMove.forEach((n, i) => {
        const id = n.id;
        toUpdate[id] = {
          ...n,
          updatedOn: fb.util.timestamp.now(),
          order: moveToPosition + i,
          toDelete: false
        };
      });

      // fix the order of the moveToCard notes
      moveToPageNotes.forEach(n => {
        if (n.order >= moveToPosition) {
          toUpdate[n.id] = { order: n.order + noteIds.length };
        }
      });
    }

    //send the update to vuex and firestore
    if (Object.keys(update).length !== 0) {
      dispatch('patch', { id: moveFromPageId, pageNotes: update });
      if (Object.keys(toUpdate).length !== 0) {
        dispatch('patch', { id: moveToPageId, pageNotes: toUpdate });
      }
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    } else {
      throw 'problems generating the update object please check that the moveLocation input value is not included in the ordersToMove Input Array';
    }
  }
};
